import { TableCell, TableRow, Tooltip } from '@mui/material';
import { FC, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { MarketSupplier } from '../../../app/services/api/orderManagementClient';
import { UserContext } from '../../../components/shared/useUser';

type Props = {
  supplier: MarketSupplier;
};

const SupplierItemRow: FC<Props> = ({ supplier }) => {
  const navigate = useNavigate();
  const { hasPermissionTo } = useContext(UserContext);

  const canEdit = hasPermissionTo(['ConfigurationAdmin']) || hasPermissionTo(['SupplierUpdate']);

  const handleRowClick = () => {
    if (!canEdit) return;
    navigate(`/suppliers/edit/${supplier.supplierId}`);
  };

  const truncateText = (text: string, maxLength: number = 30) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  return (
    <TableRow
      onClick={canEdit ? handleRowClick : undefined}
      sx={{
        cursor: canEdit ? 'pointer' : 'default',
        '&:hover': canEdit ? {
          backgroundColor: 'action.hover',
        } : undefined,
      }}
    >
      <TableCell>
        {supplier.supplierNumber}
      </TableCell>
      <TableCell>
        <Tooltip 
          title={supplier.supplierName} 
          placement="top"
        >
          <span>{truncateText(supplier.supplierName)}</span>
        </Tooltip>
      </TableCell>
      <TableCell>
        <Tooltip 
          title={supplier.emailAddress} 
          placement="top"
        >
          <span>{truncateText(supplier.emailAddress)}</span>
        </Tooltip>
      </TableCell>
      <TableCell>
        {supplier.fileFormat}
      </TableCell>
      <TableCell>
        {supplier.publishMethod}
      </TableCell>
      <TableCell align="center">
        {supplier.cutOffTime || '-'}
      </TableCell>
      <TableCell>
        <Tooltip 
          title={supplier.instanceName} 
          placement="top"
        >
          <span>{truncateText(supplier.instanceName)}</span>
        </Tooltip>
      </TableCell>
      <TableCell>
        <Tooltip 
          title={supplier.marketName || 'All Markets'} 
          placement="top"
        >
          <span>{truncateText(supplier.marketName || 'All Markets')}</span>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default SupplierItemRow;
